import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchicon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 21 21",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(1 1)",
		fill: "none",
		children: [/* @__PURE__ */ _jsx("circle", {
			stroke: "currentColor",
			strokeWidth: 2,
			cx: 7.5,
			cy: 7.5,
			r: 7.5
		}), /* @__PURE__ */ _jsx("path", {
			d: "m12.282 13.863 1.414-1.414 5.657 5.657a1 1 0 1 1-1.414 1.414l-5.657-5.657z",
			fill: "currentColor"
		})]
	})
});
export default SvgSearchicon;
